module.exports = __webpack_public_path__ + "static/media/jiantou_icon.fdd22a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/jiantou_icon.png
// module id = 703
// module chunks = 0 1